import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { VMDataService } from '../../../vm_api';
import { VeiligheidsMeter } from '../../../vm_models';

import { ContentHelper } from '../../../services/helpers/content-helper';

@Component({
  selector: 'app-errorscherm',
  templateUrl: './errorscherm.component.html',
  styleUrls: ['./errorscherm.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ErrorschermComponent implements OnInit {
  veiligheidsMeter: VeiligheidsMeter;
  pageTitle = 'Sorry, er ging iets mis';
  paza = document.body.dataset.paza || '';
  pagename = document.body.dataset.pagename || '';
  pageContent = '';

  constructor(
    private _vmDataService: VMDataService,
  ) { }

  ngOnInit() {
    this.veiligheidsMeter = this._vmDataService.getVeiligheidsMeter();
    this.pageContent= 'Probeer de <a href="../' + ContentHelper.getName() + '" id="ipoclick-btn-' + this.paza + '-' + this.pagename + '-error_terug">' + ContentHelper.getName() + '</a> later opnieuw';
    this.setPageContent();

    /* something went wrong: clear VM session / prevent loops */
    this._vmDataService.clearVeiligheidsMeter();
  }
  
  /* Set the page content */
  setPageContent() {
    let content = ContentHelper.getContent('error');

    Object.keys(content).forEach((key) => {
      let item = Object.keys(content[key])[0];

      if (this[key]) {
        let contentItem;
        
        try { 
          contentItem = this.veiligheidsMeter.vmContentItems.find(x => x.id === content[key][item])[item];
          this[key] = contentItem;
        } catch {} 
      } else {
        console.error(key, ' key not found on component');
      }
    });
  }
}
